export enum RouteName {
  Home = "Home",
  Login = "Login",
  Player = "Player",
  Channels = "Channels",
  Buffet = "Buffet",
  Settings = "Settings",
  ChannelSortAndLock = "ChannelSortAndLock",
  EditProfile = "EditProfile",
  VoD = "VoD",
  Movie = "Movie",
  TvShow = "Tv Show"
}
